import Component from '@glimmer/component';

export default class extends Component {
  get isGlobal() {
    const { option } = this.args;
    return option.constructor.modelName === 'copy-global-flow' || option.isGlobal || option.isGlobalChild;
  }
}
